import { useState } from 'react';

import usePreferredLocale from '@/hooks/usePreferredLocale';
import { NextButton,PrevButton } from '@/shared-components/buttons/components/SliderControls';
import FHSlider from '@/shared-components/sliders/components/FHSlider';
import Text from '@/shared-components/text/components/Text';
import { getCategoryDisplayLabel,getCategoryDisplayName } from '@/utils/categoryTaxonomy';

import './styles/FiltersRenderer.css';

function FiltersRendererItem({ queryKey, displayText }) {
  return (
    <div className="filters-renderer-item__container element-non-selectable">
      <Text className="filters-renderer-item__text dots-on-overflow font-size-small">
        <span>
          {queryKey}{queryKey !== "Limited Editions" && ": "}
        </span>

        {displayText}
      </Text>
    </div>
  );
}

export default function FiltersRenderer({ query }) {
  const locale = usePreferredLocale();
  const listLength = getListLength();
  const [isNextClicked, setIsNextClicked] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0); // Assuming 0 is the starting index

  const handleNextClick = () => {
    setIsNextClicked(true);
    setCurrentIndex(currentIndex + 1);
  };

  const handlePrevClick = () => {
    const newIndex = currentIndex - 1;
    if (newIndex <= 0) {
      setIsNextClicked(false);
    }
    setCurrentIndex(newIndex);
  };

  function getListLength() {
    let length = 0;
    length = query.artist ? length + query.artist.length : length;
    length = query.theme ? length + query.theme.length : length;
    length = query.emotion ? length + query.emotion.length : length;
    length = query.medium ? length + query.medium.length : length;
    length = query.color ? length + query.color.length : length;
    length = query.gallery ? length + query.gallery.length : length;
    length = query.size ? length + 1 : length;
    length = query.price ? length + 1 : length;
    length = query.limitedEditions === true ? length + 1 : length;
    return length;
  }

  if(listLength === 0) {
    return null;
  }

  return (
    <FHSlider
      className={`filters-renderer-slider-fromSearch ${isNextClicked ? 'next-clicked' : ''}`}
      customPrevButton={<PrevButton className='hide-arrow-filters' onClick={handlePrevClick} />}
      customNextButton={<NextButton className='hide-arrow-filters' onClick={handleNextClick} />}
      listLength={listLength}
    >
      {query.artist?.map(item => (
        <FiltersRendererItem
          key={item._id}
          queryKey="Artist"
          displayText={item.gallery_artist ? item.user_name : item.artist_name}
        />
      ))}

      {query.gallery?.map(item => (
        <FiltersRendererItem
          key={item._id}
          queryKey="Gallery"
          displayText={item.user_name}
        />
      ))}

      {query.price && (
        <FiltersRendererItem
          queryKey="Price"
          displayText={query.price.displayText}
        />
      )}

      {query.size && (
        <FiltersRendererItem
          queryKey="Size"
          displayText={query.size.displayText}
        />
      )}

      {query.theme?.map(item => (
        <FiltersRendererItem
          key={item}
          queryKey={getCategoryDisplayName('theme', locale)}
          displayText={getCategoryDisplayLabel('theme', item, locale)}
        />
      ))}

      {query.emotion?.map(item => (
        <FiltersRendererItem
          key={item}
          queryKey={getCategoryDisplayName('emotion', locale)}
          displayText={getCategoryDisplayLabel('emotion', item, locale)}
        />
      ))}

      {query.medium?.map(item => (
        <FiltersRendererItem
          key={item}
          queryKey={getCategoryDisplayName('medium', locale)}
          displayText={getCategoryDisplayLabel('medium', item, locale)}
        />
      ))}

      {query.color?.map(item => (
        <FiltersRendererItem
          key={item}
          queryKey={getCategoryDisplayName('color', locale)}
          displayText={getCategoryDisplayLabel('color', item, locale)}
        />
      ))}

      { query.limitedEditions === true &&
            <FiltersRendererItem
              key={'limited-editions-filter'}
              queryKey="Limited Editions"
              displayText=""
            />
      }
    </FHSlider>
  );
}
